import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

import withStyles from 'isomorphic-style-loader/withStyles';
import { useDispatch } from 'react-redux';
import ManageReservation from '../../components/ManageReservation/ManageReservation';
import { onChangeListingFilter } from '../../actions/Listing/onChangeListing';
import cs from '../../components/commonStyle.css';
import s from './ReservationContainer.css';
const ReservationContainer = (props) => {

  const dispatch = useDispatch();
  const [state, setState] = useState({
    currentPage: 1,
    listId: null,
    searchKey: '',
    startDate: null,
    endDate: null,
    orderBy: null
  });

  const setStateVariable = (variable) => {
    setState((prev) => ({
      ...prev,
      ...variable
    }));
  };

  const prevTypeRef = useRef(type);

  useEffect(() => {
    if (prevTypeRef.current !== type) {
      setState((prev) => ({
        ...prev,
        currentPage: 1
      }));
      prevTypeRef.current = type;
    }
  }, [type]);

  useEffect(() => {
    dispatch(onChangeListingFilter({
      orderBy: null,
      startDate: null,
      endDate: null,
      listId: null
    }));
  }, []);

  const { userType, type } = props;
  const { listId, orderBy, startDate, endDate, currentPage, searchKey } = state;

  return (
    <ManageReservation
      searchKey={searchKey}
      userType={userType}
      type={type}
      listId={listId}
      orderBy={orderBy}
      startDate={startDate}
      endDate={endDate}
      currentPage={currentPage}
      setStateVariable={setStateVariable}
    />
  );
}

ReservationContainer.propTypes = {
  formatMessage: PropTypes.func,
  userType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default compose(withStyles(cs, s))(ReservationContainer);